import { triggerAction } from "./actions"

const INITIAL_STATE = {
    show: false,
    triggeredActionId: null,
    props: {
        icon: null, 
        title: null, 
        description: null, 
        primaryAction: null, 
        primaryActionLabel: null, 
        secondaryAction: triggerAction("layout/voltar"),
        secondaryActionLabel: "Voltar", 
        noAction: false
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case 'FEEDBACK_LIMPAR': {
            return {...INITIAL_STATE}
        }
        case 'SET_FEEDBACK': {
            return { props: action.payload || INITIAL_STATE.props, show: true }
        }
        case 'FEEDBACK_TRIGGER_ACTION': {
            return { ...state, triggeredActionId: action.payload, show: false }
        }
        default:
            return state;
    }
}